import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from '../../app-material/app-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

import { LoginRoutingModule } from './login-routing.module';

import { LoginComponent } from './login.component';
import { InputErrorPipeModule } from '../../pipes/input-error-pipe.module';
import { LoginFormComponent } from './login-form/login-form.component';
import { HeaderModule } from '../../core-components/header/header.module';
import { FooterModule } from '../../core-components/footer/footer.module';
import { SidenavModule } from '../../core-components/sidenav/sidenav.module';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    HttpClientModule,
    TranslateModule,
    FlexLayoutModule,
    LoginRoutingModule,
    HeaderModule,
    FooterModule,
    SidenavModule,
    InputErrorPipeModule
  ],
  declarations: [
    LoginFormComponent,
    LoginComponent,
  ],
  bootstrap: [LoginComponent]
})
export class LoginModule { }